var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.061,
    height: 119.305,
    viewBox: "0 0 115.061 119.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M91.172,38.961C83.118,38.961,76.79,33,76.79,25.4V6.423C76.79,3.169,74.489,1,71.037,1H25.012C12.356,1,2,10.761,2,22.692V98.614c0,11.931,10.356,21.692,23.012,21.692H94.049c12.657,0,23.012-9.761,23.012-21.692V44.384c0-3.254-2.3-5.423-5.753-5.423ZM71.037,87.768H36.518c-3.452,0-5.753-2.169-5.753-5.423s2.3-5.423,5.753-5.423H71.037c3.452,0,5.753,2.169,5.753,5.423S74.489,87.768,71.037,87.768ZM82.543,66.076H36.518c-3.452,0-5.753-2.169-5.753-5.423s2.3-5.423,5.753-5.423H82.543c3.452,0,5.753,2.169,5.753,5.423S85.995,66.076,82.543,66.076Z",
    transform: "translate(-2 -1)",
    fill: "#117446"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.33a1b406807be886ebd18691fb839bf9.svg";
export { ForwardRef as ReactComponent };